import { Project } from "stores/projectStore"
import { User } from "stores/userStore"

/**
 * Enum for user role types
 */
export enum USER_ROLE {
  ADMIN = "admin",
  SUPER_ADMIN = "super-admin",
  USER = "user",
}

/**
 * Type for user role values
 */
export type UserRoleType =
  | USER_ROLE.ADMIN
  | USER_ROLE.SUPER_ADMIN
  | USER_ROLE.USER

/**
 * Helper function to check if a role key is a valid user role
 * @param roleKey - The role key to validate
 * @returns boolean indicating if the role is valid
 */
export const isValidUserRole = (roleKey: string): roleKey is UserRoleType => {
  return Object.values(USER_ROLE).includes(roleKey as USER_ROLE)
}

///TODO Move this to a more appropriate location
/**
 * Helper function to check if a user has admin privileges
 * @param roleKey - The role key to check
 * @returns boolean indicating if the role has admin privileges
 */
export const hasAdminPrivileges = (roleKey: string): boolean => {
  return roleKey === USER_ROLE.ADMIN || roleKey === USER_ROLE.SUPER_ADMIN
}

/**
 * Helper function to check if a user has super admin privileges
 * @param roleKey - The role key to check
 * @returns boolean indicating if the role has super admin privileges
 */
export const isSuperAdmin = (roleKey: string): boolean => {
  return roleKey === USER_ROLE.SUPER_ADMIN
}

/**
 * Helper function to check if a user has ownership privileges for a project
 * (checks if user is the project owner)
 * @param project - The project to check
 * @param user - The user to check against
 * @returns boolean indicating if the user has ownership privileges
 */
export const hasOwnershipPrivileges = (
  project: Project,
  user: User
): boolean => {
  if (!project.Owner || !user.username) return false
  return project.Owner.toLowerCase() === user.username.toLowerCase()
}
